import { render, staticRenderFns } from "./applicationUsersFormbuilder.vue?vue&type=template&id=b2177d88&scoped=true"
import script from "./applicationUsersFormbuilder.vue?vue&type=script&lang=js"
export * from "./applicationUsersFormbuilder.vue?vue&type=script&lang=js"
import style0 from "./applicationUsersFormbuilder.vue?vue&type=style&index=0&id=b2177d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2177d88",
  null
  
)

export default component.exports